class ShopByCategoryTabs extends HTMLElement {
  constructor() {
    super();
    this.section = this.closest('.shop-by-category');
    this.tabs = this.section ? this.section.querySelectorAll('.shop-by-category__tab') : [];

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.selectTab(tab));
    });
  }

  selectTab(activeTab) {
    const index = activeTab.dataset.tabIndex;

    this.tabs.forEach((tab) => {
      const isActive = tab === activeTab;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this.querySelectorAll('.shop-by-category__panel').forEach((panel) => {
      const isActive = panel.dataset.tabPanel === index;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });
  }
}

customElements.define('shop-by-category-tabs', ShopByCategoryTabs);
